import { render, staticRenderFns } from "./PublishDateSlider.vue?vue&type=template&id=bea07352&scoped=true&"
import script from "./PublishDateSlider.vue?vue&type=script&lang=js&"
export * from "./PublishDateSlider.vue?vue&type=script&lang=js&"
import style0 from "./PublishDateSlider.vue?vue&type=style&index=0&id=bea07352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea07352",
  null
  
)

export default component.exports